<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Lecciones</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="row">
          <div class="col-md-6">
            <div class="col-3">
              <b-form-group
                id="input-group-3"
                label="Estado:  "
                label-for="input-3"
              >
                <b-form-select
                  id="input-3"
                  v-model="selectedStatus"
                  :options="[
                    { text: 'Activas', value: 'list' },
                    { text: 'Inactivas', value: 'listInactive' },
                  ]"
                  required
                  @change="this.loadLessons"
                  class="ml-2 mt-2"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>

          <div class="col-md-6">

            <div class="text-right" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
              <router-link to="/admin-panel/lecciones/create">
                <b-button variant="primary">
                  <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Crear Lección
                </b-button>
              </router-link>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="lessonsItems" :fields="fields">

              <!-- A virtual column -->
              <template #cell(actions)="data" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                <b-dropdown id="dropdown-1" text="Acciones" class="m-md-1">
                  <b-dropdown-item>
                    <router-link :to="{ name: 'LessonsEdit', params: { id: data.item.id}}" >
                      <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                    </router-link>
                  </b-dropdown-item>

                  <div v-if="userPermission !== 'ROLE_TEACHER'">
                    <b-dropdown-item v-if="data.item.active == false" @click="enableModule(data.item.id)">
                    <a href="#">
                      <font-awesome-icon icon="fas fa-check-to-slot" />&nbsp;Activar</a>
                  </b-dropdown-item>
                  </div>

                  <div v-if="userPermission !== 'ROLE_TEACHER'">
                    <b-dropdown-item v-if="data.item.active == true" @click="disableModule(data.item.id)">
                      <a href="#">
                      <font-awesome-icon icon="fas fa-ban"/>&nbsp;Desactivar</a>
                    </b-dropdown-item>
                  </div>

                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"

            ></b-pagination>
          </div>
        </div>
      </div>
      <div v-if="userPermission === 'ROLE_ADMIN' || userPermission === 'ROLE_ENABLING_TEACHER'">

      <!-- DataTales Example -->




    </div>
  </div>
    <!-- /.container-fluid -->

  </div>
  <!-- End of Main Content -->
</template>

<script>
import axios from "axios";

export default {
  name: "SimulacrumsAdmin",
  data: () => {
    return {
      fields: [
        {
          key: "title",
          sortable: true,
          label: "Título",
          class: "w-25",
        },
        {
          key: "actions",
          label: "",
          sortable: true,
          class: "w-25",
        },
      ],
      simulacrumItems: [],
      modulesInactiveItems: [],
      lessonsItems: [],
      currentPage: 1,
      rows: 10000,
      perPage: 10,
      search: "",
      selectedStatus: "list",
      userPermission: "",
      role: "",
      roleName: ""


    };
  },
  methods: {
    enableModule(id) {
      let loader = this.$loading.show({});
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/lessons/enable/" + id , {lessonId: id},{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$router.go();
        console.log(result);
        loader.hide();
      });
    },
    disableModule(id) {
      let loader = this.$loading.show({});
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/lessons/disable/" + id,{lessonId: id},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$router.go();
          console.log(result);
          loader.hide();
        });
    },
    enableSimulacrums(id) {
      let loader = this.$loading.show({});
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/enable/" + id,{simulacumId: id},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$router.go();
          console.log(result);
          loader.hide();
        })
        .catch((err) => {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "No se ha alcanzado el minimo de preguntas"
          );
          console.log(err.message);
          loader.hide();
        });
    },
    disableSimulacrums(id) {
      let loader = this.$loading.show({});
      axios
        .post(
          import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/disable/" + id,{simulacumId: id},
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((result) => {
          this.$router.go();
          console.log(result);
          loader.hide();
        });
    },
    loadLessons() {
      let loader = this.$loading.show({});
      let lessonStatus = this.selectedStatus;
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/lessons/" + lessonStatus,
          {
            params: { page: this.currentPage, size: this.perPage, sort: 'DESC', },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          loader.hide();
          this.lessonsItems = response.data;
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
      }
  },
  loadQuery() {
      this.$nextTick(function() {
        this.$router.push({ path: '/admin-panel/simulacrum', query: { search: this.search, searchCreatedBy: this.search2, module: this.selectedModule, simulacrumPage: 1, questionsInactivePage: this.currentInactivePage, status: this.selectedStatus}});
        this.$router.go();
      });
    },
  beforeMount() {
    let auth = JSON.parse(window.localStorage.getItem("auth"));
    if (!auth.isAuthenticated) {
      window.location.href = '/'
    }
    this.userName =  auth.data.name;
    this.role = window.localStorage.getItem("role");

    if (this.role === 'ROLE_STUDENT') {
      window.location.href = '/'
    }
  },
  watch: {
    currentPage: function () {
      this.loadLessons();
    },
  },
  mounted() {
    this.userPermission = localStorage.getItem("role");
    this.loadLessons();
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
};
</script>

<style scoped></style>
